module.exports = __webpack_public_path__ + "static/media/11.31bf806f.svg";